// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__25c9C","mt20":"style_mt20__1aEkw","mb24":"style_mb24__3uLjl","box":"style_box__14JBB","container":"style_container__3pPza"};